import { render, staticRenderFns } from "./UsageDetails.vue?vue&type=template&id=06da2c68&scoped=true"
import script from "./UsageDetails.vue?vue&type=script&lang=js"
export * from "./UsageDetails.vue?vue&type=script&lang=js"
import style0 from "./UsageDetails.vue?vue&type=style&index=0&id=06da2c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da2c68",
  null
  
)

export default component.exports